import {isUndefined} from "lodash";

export class ParticipantsContestantLinkController {
    public contestant: any;
    public league: any;
    public isTeam: boolean;

    public $onChanges() {
        if (this.contestant) {
            this.isTeam = !isUndefined(this.contestant.getMemberCount);
        }
    }

    public isRosterLeague(): boolean {
        return this.league && this.league.enabledFeatures.indexOf("roster") !== -1;
    }
}